import type { UseFormRegisterReturn } from 'react-hook-form';

import { ButtonStroked } from '~shared/ui/atoms/Buttons/ButtonStroked';
import { HiddenInput } from '~shared/ui/atoms/HiddenInput';

export const FilterButton = ({
	id,
	text,
	href,
	value,
	selected,
	registration,
	skeleton = false,
	onClick,
}: {
	id?: string;
	text: string;
	href?: string;
	value?: string;
	selected: boolean;
	skeleton?: boolean;
	registration?: UseFormRegisterReturn;
	onClick?: () => void;
}) => {
	return (
		<>
			{href ? (
				<ButtonStroked
					href={href}
					size="M"
					selected={selected}
					disabled={selected}
					onClick={onClick}
					skeleton={skeleton}
				>
					{text}
				</ButtonStroked>
			) : (
				<ButtonStroked
					htmlFor={id}
					size="M"
					selected={selected}
					disabled={selected}
					skeleton={skeleton}
					onClick={onClick}
				>
					{text}
				</ButtonStroked>
			)}

			{registration && (
				<HiddenInput id={id} type="radio" {...registration} value={value} />
			)}
		</>
	);
};
